import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle, WarningCircle, X } from 'phosphor-react';
import { alertAtom } from '_state';
import { useAlertActions } from '_actions';
import { cn } from './cn';

// Global toast bound to the alert atom. Auto-dismisses; mount once near the app root.
export function Toast() {
    const alert = useRecoilValue(alertAtom);
    const { clear } = useAlertActions();
    const visible = !!alert?.message;

    useEffect(() => {
        if (!visible) return undefined;
        const t = setTimeout(clear, 4500);
        return () => clearTimeout(t);
    }, [visible, alert?.message, alert?.description, clear]);

    const isError = alert?.type === 'error';
    const Icon = isError ? WarningCircle : CheckCircle;

    return (
        <div className="pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4">
            <AnimatePresence>
                {visible && (
                    <motion.div
                        initial={{ opacity: 0, y: 24, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 12, scale: 0.98 }}
                        transition={{ duration: 0.4, ease: [0.32, 0.72, 0, 1] }}
                        className="pointer-events-auto flex max-w-md items-start gap-3 rounded-2xl bg-espresso px-5 py-4 text-cream shadow-ambient-lg"
                    >
                        <Icon size={22} weight="fill" className={cn('mt-0.5 shrink-0', isError ? 'text-clay-soft' : 'text-sage-soft')} />
                        <div className="min-w-0">
                            <p className="font-medium">{alert.message}</p>
                            {alert.description && <p className="mt-0.5 text-sm text-cream/70">{alert.description}</p>}
                        </div>
                        <button aria-label="Đóng" onClick={clear} className="-mr-1 ml-2 rounded-full p-1 text-cream/60 transition-colors hover:text-cream">
                            <X size={16} weight="bold" />
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
